import axios from "axios";

export const getError = (error) => {
  return error.response && error.response.data.message
    ? error.response.data.message
    : error.message;
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Reads the backend URL from the .env file
});

export default instance;
